export const selectStyles = (theme) => ({
  root: {
    width: theme.wrappers.fullWidth,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
});
